<template>
  <router-view />
</template>
<script>
export default {
  name: 'Ttec',
};
</script>
